import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Breadcrumb from "sushiweb/Breadcrumb";
import { FlexContainer, Heading } from "../../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory, useParams } from "react-router-dom";
import { getPath } from "../../../utils/index";
import * as DriverNotificationActions from "../../../store/actions/DriverNotification";
import CampaignInfo from "../../../components/DriverNotification/CampaignInfo";
import Dropdown from "sushiweb/Dropdown";
import MenuItem from "sushiweb/MenuItem/MenuItem";
import Back from "sushiweb/Icons/all/Back";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import Permission from "../../../components/Common/Permission";
import variables from "../../../constants/assets/variables";

const CampaignDetails = ({ activeCampaignDetails, getActiveCampaign }) => {
  const { id } = useParams();
  const history = useHistory();
  const [langId, setLangId] = useState("");
  const allActions = MenuActionsMappings[MenuNames.DRIVER_NOTIFICATION];

  const handleLangChange = (langId) => {
    setLangId(langId);
    getActiveCampaign(id, langId);
  };

  const getValue = () => {
    if (
      activeCampaignDetails &&
      activeCampaignDetails["languages"] &&
      activeCampaignDetails["languages"]["selected"] &&
      activeCampaignDetails["languages"]["selected"]["label"]
    ) {
      return activeCampaignDetails["languages"]["selected"]["label"];
    }
  };

  const handleBackClick = () => {
    history.push(`/notification_campaigns`);
  };

  useEffect(() => {
    Object.keys(activeCampaignDetails).length == 0 && getActiveCampaign(id);
  }, []);

  return (
    <div className="container">
      <Heading>&emsp;Scheduled Notifications</Heading>
      <FlexContainer align="flex-start">
        <div>
          <FlexContainer>
            &emsp;&emsp;
            <Back
              onClick={handleBackClick}
              className="mr-10 backBtn"
              color={variables.grey400}
            />
            <Breadcrumb className="sushi-breadcrumbs">
              <Breadcrumb.Link linkTo="/notification_campaigns">
                Notifications
              </Breadcrumb.Link>
              <Breadcrumb.Link>Notification View</Breadcrumb.Link>
            </Breadcrumb>
          </FlexContainer>
        </div>
        <LanguageDropdown>
          <Permission requiredPerms={[allActions.CAMPAIGN_VIEW]}>
            <Dropdown
              onSelect={handleLangChange}
              value={getValue()}
              borderColor={variables.primaryColor}
              className="sushi-dropdown"
            >
              {activeCampaignDetails.languages &&
                getPath(activeCampaignDetails.languages, "list", []).map(
                  (lang, index) => {
                    return (
                      <MenuItem
                        value={lang.value}
                        label={lang.label}
                        key={index}
                      />
                    );
                  }
                )}
            </Dropdown>
          </Permission>
        </LanguageDropdown>
      </FlexContainer>
      <CampaignInfo activeCampaignDetails={activeCampaignDetails} />
    </div>
  );
};

const LanguageDropdown = styled.div`
  flex: 0 1 50%;
  .sushi-dropdown {
    width: 50%;
  }
`;

function mapStateToProps(state) {
  const { DriverNotification } = state;
  return {
    activeCampaignDetails: DriverNotification.activeCampaignDetails,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getActiveCampaign: bindActionCreators(
      DriverNotificationActions.getActiveCampaign,
      dispatch
    ),
    resetState: bindActionCreators(
      DriverNotificationActions.resetState,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CampaignDetails);
